/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * Sklls API
 * OpenAPI spec version: v1
 */
export type AccessLevel = (typeof AccessLevel)[keyof typeof AccessLevel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AccessLevel = {
  CanRead: 'CanRead',
  CanEdit: 'CanEdit',
  CanAdministrate: 'CanAdministrate'
} as const;

export interface AddBlockCommand {
  id?: number;
  /** @nullable */
  name: string | null;
  type?: BlockType;
  /** @nullable */
  description?: string | null;
  qualityLevel?: QualityLevel;
  /** @nullable */
  globalAssetIntents?: GlobalAssetIntent[] | null;
  /** @nullable */
  aiResponses?: AiVoiceResponse[] | null;
  /** @nullable */
  intentPhrases?: IntentPhrase[] | null;
  posX?: number;
  posY?: number;
  scenario?: Scenario;
  scenarioId?: number;
  scores?: number;
  /** @nullable */
  frontendBlockId?: string | null;
  /** @nullable */
  scenarioPersonaId?: number | null;
  scenarioPersona?: ScenarioPersona;
}

export interface AddBlockLinkCommand {
  id?: number;
  origin?: Block;
  originId?: number;
  target?: Block;
  targetId?: number;
  scenario?: Scenario;
  scenarioId?: number;
  /** @nullable */
  frontendOriginId?: string | null;
  /** @nullable */
  frontendTargetId?: string | null;
}

export interface AddDialogStatisticCommand {
  sessionId?: string;
  endReason?: EndReason;
  isPhoneConversation?: boolean;
  /** @nullable */
  phoneNumber?: string | null;
}

export interface AddScenarioCommand {
  id?: number;
  /** @nullable */
  createdBy?: number | null;
  /** @nullable */
  modifiedBy?: number | null;
  createdByUser?: User;
  modifiedByUser?: User;
  createdDate?: string;
  modifiedDate?: string;
  versionId?: number;
  /** @nullable */
  companyId?: number | null;
  /** @nullable */
  name: string | null;
  /** @nullable */
  description?: string | null;
  speed?: number;
  /** @nullable */
  langCode: string | null;
  /** @nullable */
  evaluationProtocolElements?: EvaluationProtocolElement[] | null;
  /** @nullable */
  blocks?: Block[] | null;
  /** @nullable */
  blockLinks?: BlockLink[] | null;
  /** @nullable */
  courses?: Course[] | null;
  sceneGroup?: ScenarioGroup;
  centerX?: number;
  centerY?: number;
  scale?: number;
  /** @nullable */
  scenarioContextIntro?: string | null;
  playScenarioContextOn?: boolean;
  /** @nullable */
  scenarioGroupId?: number | null;
  contextId?: number;
  context?: ScenarioContext;
  /**
   * @deprecated
   * @nullable
   */
  contexts?: ScenarioContext[] | null;
  isLlmEnabled?: boolean;
  llm?: Llm;
  /** @nullable */
  sharedCompanies?: Company[] | null;
  /** @nullable */
  scenarioCompanies?: ScenarioCompany[] | null;
  /** @nullable */
  scenarioPersonas?: ScenarioPersona[] | null;
  /** @nullable */
  variables?: Variable[] | null;
  /** @nullable */
  attachments?: FileAttachment[] | null;
  isPublished?: boolean;
  useStreaming?: boolean;
  isDecisionSupportEnabled?: boolean;
  notesEnabled?: boolean;
  /** @nullable */
  notesEvaluationProtocolElements?: EvaluationProtocolElement[] | null;
  maxTokens?: number;
}

export interface AddUsersToGroupCommand {
  /** @nullable */
  users?: number[] | null;
}

export interface AiVoiceResponse {
  id?: number;
  /** @nullable */
  text: string | null;
  voiceResponseUsecase?: VoiceResponseUsecase;
}

export interface AiVoiceResponseDto {
  id?: number;
  /** @nullable */
  text: string | null;
  voiceResponseUsecase?: VoiceResponseUsecase;
}

export interface ApplyExerciseScheduleChangeDto {
  /**
   * @minLength 0
   * @maxLength 200
   */
  title: string;
  /**
   * @minLength 0
   * @maxLength 2000
   * @nullable
   */
  description?: string | null;
  scheduledDateTime: string;
  scheduledEndDateTime: string;
  cascadeMode: ExerciseScheduleCascadeMode;
  originalScheduledDateTime: string;
  originalScheduledEndDateTime: string;
}

export interface ApplyExerciseScheduleChangeResponseDto {
  exercise: ExerciseDto;
  shiftedItemCount?: number;
  shiftMinutes?: number;
  cascadeMode?: ExerciseScheduleCascadeMode;
  endDateAutoAdjusted?: boolean;
}

export interface ApplyPlaybookItemTimeChangeDto {
  scenarioId: number;
  /**
   * @minLength 0
   * @maxLength 2000
   * @nullable
   */
  description?: string | null;
  scheduledDateTime: string;
  /** @nullable */
  fromExerciseContactId?: number | null;
  toExerciseContactId: number;
  cascadeMode: PlaybookTimeCascadeMode;
  originalItemScheduledDateTime: string;
  expectedExerciseScheduledDateTime: string;
  expectedExerciseScheduledEndDateTime: string;
}

export interface ApplyPlaybookItemTimeChangeResponseDto {
  item: PlaybookItemDto;
  shiftedItemCount?: number;
  shiftMinutes?: number;
  cascadeMode?: PlaybookTimeCascadeMode;
}

export interface AttachmentDto {
  /** @nullable */
  url: string | null;
  /** @nullable */
  fileName: string | null;
  fileSize?: number;
}

export interface AudioResponseDto {
  /** @nullable */
  text: string | null;
  /** @nullable */
  audio: string | null;
  /** @nullable */
  lastBlockId?: number | null;
  isEnd?: boolean;
  persona: ScenarioPersonaDto;
  /** @nullable */
  avatarUrl?: string | null;
}

export interface Avatar {
  /** @nullable */
  collection?: string | null;
  gender?: Gender;
  /** @nullable */
  url?: string | null;
}

export interface Block {
  id?: number;
  /** @nullable */
  name: string | null;
  type?: BlockType;
  /** @nullable */
  description?: string | null;
  qualityLevel?: QualityLevel;
  /** @nullable */
  globalAssetIntents?: GlobalAssetIntent[] | null;
  /** @nullable */
  aiResponses?: AiVoiceResponse[] | null;
  /** @nullable */
  intentPhrases?: IntentPhrase[] | null;
  posX?: number;
  posY?: number;
  scenario?: Scenario;
  scenarioId?: number;
  scores?: number;
  /** @nullable */
  frontendBlockId?: string | null;
  /** @nullable */
  scenarioPersonaId?: number | null;
  scenarioPersona?: ScenarioPersona;
}

export interface BlockDto {
  id?: number;
  /** @nullable */
  name: string | null;
  type?: BlockType;
  /** @nullable */
  description?: string | null;
  qualityLevel?: QualityLevel;
  /** @nullable */
  globalAssetIntents?: GlobalAssetIntentDto[] | null;
  /** @nullable */
  aiResponses?: AiVoiceResponseDto[] | null;
  /** @nullable */
  intentPhrases?: IntentPhraseDto[] | null;
  posX?: number;
  posY?: number;
  sceneId?: number;
  /** @nullable */
  scenarioPersonaId?: number | null;
}

export interface BlockLink {
  id?: number;
  origin?: Block;
  originId?: number;
  target?: Block;
  targetId?: number;
  scenario?: Scenario;
  scenarioId?: number;
}

export interface BlockLinkDto {
  id?: number;
  origin: BlockDto;
  originId?: number;
  target: BlockDto;
  targetId?: number;
  sceneId?: number;
}

export type BlockType = (typeof BlockType)[keyof typeof BlockType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BlockType = {
  Normal: 'Normal',
  Start: 'Start',
  End: 'End',
  Service: 'Service'
} as const;

export interface BulkRescheduleStoreProvisionalDialogStatisticRequest {
  /** Lookback window in minutes from current UTC time. */
  lookbackMinutes?: number;
  /** If true, returns candidates only and does not enqueue new jobs. */
  dryRun?: boolean;
  /** If true, only includes sessions where the corresponding DialogStatistic is missing or not finalized. */
  onlyMissingOrUnendedStatistics?: boolean;
}

export interface CloneExerciseResponseDto {
  id: number;
  /** @nullable */
  title: string | null;
}

export interface Company {
  id?: number;
  /** @nullable */
  name: string | null;
  /** @nullable */
  users?: User[] | null;
  /** @nullable */
  departments?: CompanyDepartment[] | null;
  /** @nullable */
  scenarios?: Scenario[] | null;
  /** @nullable */
  scenarioGroups?: ScenarioGroup[] | null;
  /** @nullable */
  sharedScenarios?: Scenario[] | null;
  /** @nullable */
  sharedGlobalAssetCategories?: GlobalAssetCategory[] | null;
  /** @nullable */
  globalAssetCategories?: GlobalAssetCategory[] | null;
  /** @nullable */
  readonly externalName?: string | null;
  /** @nullable */
  groups?: Group[] | null;
  /** @nullable */
  tenants?: Tenant[] | null;
  /** @nullable */
  defaultLanguage?: string | null;
  /** @nullable */
  licenseAgreements?: LicenseAgreement[] | null;
  /** @nullable */
  evaluationProtocolCompanies?: EvaluationProtocolCompany[] | null;
  /** @nullable */
  personaCompanies?: PersonaCompany[] | null;
  /** @nullable */
  roleCompanies?: RoleCompany[] | null;
}

export interface CompanyDepartment {
  id?: number;
  /** @nullable */
  name: string | null;
  companyId?: number;
  company?: Company;
  /** @nullable */
  licenseAgreements?: LicenseAgreement[] | null;
}

export interface CompanyDepartmentDto {
  id?: number;
  /** @nullable */
  name?: string | null;
  companyId?: number;
}

export interface CompanyDto {
  id?: number;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  defaultLanguage?: string | null;
  /** @nullable */
  sceneGroups?: ScenarioGroupDto[] | null;
  /** @nullable */
  scenes?: ScenarioDto[] | null;
}

export interface ConversationExportFilterDto {
  /** @nullable */
  from?: string | null;
  /** @nullable */
  to?: string | null;
  /** @nullable */
  search?: string | null;
  /** @nullable */
  companyName?: string | null;
  /** @nullable */
  departmentName?: string | null;
  /** @nullable */
  scenarioName?: string | null;
  /** @nullable */
  userName?: string | null;
  /** @nullable */
  durationMin?: number | null;
  /** @nullable */
  durationMax?: number | null;
  /** @nullable */
  scoreMin?: number | null;
  /** @nullable */
  scoreMax?: number | null;
  /** @nullable */
  isPhoneConversation?: boolean | null;
  /** @nullable */
  timeZoneId?: string | null;
  /** @nullable */
  requestedByUserId?: number | null;
  sortOrder?: SortType;
  /** @nullable */
  orderBy?: string | null;
  format?: ExportFormat;
}

export interface ConversationFeedback {
  emoji?: FeedbackEmoji;
  /** @nullable */
  feedback?: string | null;
  /** @nullable */
  metadata?: string | null;
}

export interface ConvertFromSharedScenarioCommand {
  targetCompanyId?: number;
}

export interface CopyScenarioCommand {
  id?: number;
  /** @nullable */
  newName?: string | null;
  /** @nullable */
  companyId?: number | null;
  /** @nullable */
  targetLanguage?: string | null;
  shareProtocols?: boolean;
  sharePersonas?: boolean;
}

export interface Course {
  id?: number;
  /** @nullable */
  createdBy?: number | null;
  /** @nullable */
  modifiedBy?: number | null;
  createdByUser?: User;
  modifiedByUser?: User;
  createdDate?: string;
  modifiedDate?: string;
  /** @nullable */
  companyId?: number | null;
  /** @nullable */
  title: string | null;
  company?: Company;
  /** @nullable */
  scenarios?: Scenario[] | null;
  /** @nullable */
  scheduledCourses?: ScheduledCourse[] | null;
}

export interface CourseDto {
  id?: number;
  /** @nullable */
  createdBy?: number | null;
  /** @nullable */
  createdByUserName?: string | null;
  createdDate?: string;
  /** @nullable */
  modifiedByUserName?: string | null;
  /** @nullable */
  title?: string | null;
  companyId?: number;
  /** @nullable */
  companyName?: string | null;
  scenesCount?: number;
  /** @nullable */
  scenes?: CourseScenarioDto[] | null;
  /** @nullable */
  scheduledCourses?: ScheduledCourseDto[] | null;
}

export interface CourseScenarioDto {
  id?: number;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  description?: string | null;
}

export interface CreateCompanyCommand {
  /** @nullable */
  name?: string | null;
}

export interface CreateCompanyDepartmentCommand {
  /** @nullable */
  name?: string | null;
}

export interface CreateCourseCommand {
  companyId?: number;
  /** @nullable */
  title?: string | null;
  /** @nullable */
  duration?: number | null;
}

export interface CreateEvaluationProtocolCategoryCommand {
  evaluationProtocolId?: number;
  /** @nullable */
  name?: string | null;
}

export interface CreateEvaluationProtocolCommand {
  /** @nullable */
  companies?: ProtocolCompanyAccessDto[] | null;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  languageCode?: string | null;
  /** @nullable */
  items?: CreateEvaluationProtocolElementCommand[] | null;
}

export interface CreateEvaluationProtocolElementCommand {
  evaluationProtocolId?: number;
  evaluationProtocolCategoryId?: number;
  /** @nullable */
  name?: string | null;
  type?: EvaluationProtocolElementType;
  /** @nullable */
  scaleMin?: number | null;
  /** @nullable */
  scaleMax?: number | null;
  /** @nullable */
  choices?: string | null;
  explanationEnabled?: boolean;
  /** @nullable */
  description?: string | null;
}

export interface CreateExerciseContactDto {
  /**
   * @minLength 0
   * @maxLength 200
   */
  name: string;
  /**
   * @minLength 0
   * @maxLength 50
   */
  phoneNumber: string;
  /** @minLength 1 */
  type: string;
}

export interface CreateExerciseDto {
  /**
   * @minLength 0
   * @maxLength 200
   */
  title: string;
  /**
   * @minLength 0
   * @maxLength 2000
   * @nullable
   */
  description?: string | null;
  scheduledDateTime: string;
  scheduledEndDateTime: string;
  /** @nullable */
  contactList?: CreateExerciseContactDto[] | null;
  /** @nullable */
  playbook?: CreatePlaybookItemDto[] | null;
}

export interface CreateGlobalAssetCategoryCommand {
  /** @nullable */
  title?: string | null;
  /** @nullable */
  language?: string | null;
  /** @nullable */
  shared?: boolean | null;
}

export interface CreateGlobalAssetIntentCommand {
  /** @nullable */
  title?: string | null;
  /** @nullable */
  samples?: string[] | null;
}

export interface CreateLicenseAgreementDto {
  companyId: number;
  /** @nullable */
  departmentId?: number | null;
  /**
   * @minimum 0
   * @maximum 2147483647
   */
  skllsSeats: number;
  /**
   * @minimum 0
   * @maximum 2147483647
   */
  interpreterSeats: number;
  /**
   * @minimum 0
   * @maximum 2147483647
   */
  exercisesSeats: number;
  startTime: string;
  expiryTime: string;
}

export interface CreateOrganizationInvitationCommand {
  companyId?: number;
  /** @nullable */
  departmentId?: number | null;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  tenantId?: string | null;
  /** @nullable */
  tenantDomain?: string | null;
  hasSklls?: boolean;
  hasInterpreter?: boolean;
  hasExercises?: boolean;
  role?: UserRole;
}

/**
 * DTO for creating a new persona.
 */
export interface CreatePersonaDto {
  /**
   * The name of the persona.
   * @minLength 0
   * @maxLength 100
   */
  name: string;
  /**
   * Optional description of the persona.
   * @minLength 0
   * @maxLength 500
   * @nullable
   */
  description?: string | null;
  /**
   * The language code for the persona (e.g., "en-US", "sv-SE").
   * @minLength 0
   * @maxLength 10
   */
  languageCode: string;
  gender: Gender;
  ttsProvider: TtsProvider;
  /**
   * The voice name to use with the TTS provider. Deprecated; prefer voiceId.
   * @minLength 0
   * @maxLength 100
   */
  voiceName: string;
  /**
   * Provider-stable voice identifier (e.g., Azure ShortName, Google voice name, ElevenLabs voice_id).
   * @minLength 0
   * @maxLength 100
   * @nullable
   */
  voiceId?: string | null;
  /**
   * Optional URL to an avatar image for the persona.
   * @minLength 0
   * @maxLength 500
   * @nullable
   */
  avatarUrl?: string | null;
}

export interface CreatePlaybookItemDto {
  scenarioId: number;
  /**
   * @minLength 0
   * @maxLength 2000
   * @nullable
   */
  description?: string | null;
  scheduledDateTime: string;
  /** @nullable */
  fromExerciseContactId?: number | null;
  toExerciseContactId: number;
}

export interface CreateRoleDto {
  /** @nullable */
  name: string | null;
  /** @nullable */
  languageCode: string | null;
  /** @nullable */
  description?: string | null;
  /** @nullable */
  companyId?: number | null;
}

export interface CreateScheduledCallCommand {
  scenarioId?: number;
  scheduledTime?: string;
  /** @nullable */
  targetName?: string | null;
  /** @nullable */
  userId?: number | null;
  /** @nullable */
  phoneNumber?: string | null;
  companyId?: number;
}

export interface CreateScheduledCourseCommand {
  /** @nullable */
  departmentId?: number | null;
  startDate?: string;
  endDate?: string;
  addAllUsers?: boolean;
}

export interface CreateScheduledCourseNotificationCommand {
  date?: string;
  /** @nullable */
  customText?: string | null;
}

export interface CreateUserGroupCommand {
  /** @nullable */
  companyId?: number | null;
  /** @nullable */
  departmentId?: number | null;
  /** @nullable */
  title?: string | null;
}

export interface DecisionSupportRequest {
  sessionId: string;
  /**
   * Message from the caller (patient/innringer) that requires operator advice
   * @nullable
   */
  callerMessage?: string | null;
  /**
   * The operator's actual response to the previous third party message (for conversation tracking)
   * @nullable
   */
  operatorResponse?: string | null;
}

export interface DecisionSupportResponse {
  sessionId?: string;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  completedTasks?: string[] | null;
  isEnd?: boolean;
}

/**
 * Structured response for decision support providing tactical guidance to emergency operators.
Contains the four key components of operator guidance in a structured format for frontend consumption.
 */
export interface DecisionSupportStructuredResponseDto {
  sessionId?: string;
  /**
   * Brief recommendation for the operator's next action
   * @nullable
   */
  suggest?: string | null;
  /**
   * Exact wording the operator can use with the caller
   * @nullable
   */
  say?: string | null;
  /**
   * Brief justification based on observations or protocol; flags uncertainty if lacking data
   * @nullable
   */
  rationale?: string | null;
  /**
   * Control questions or observations the operator should make now; 'Ingen' if not applicable
   * @nullable
   */
  checks?: string | null;
  /**
   * List of completed tasks in this interaction
   * @nullable
   */
  completedTasks?: string[] | null;
  /** Indicates if this is the end of the conversation */
  isEnd?: boolean;
}

export interface DeleteCompanyCommand {
  id?: number;
  onCompanyDeleteAction?: OnCompanyDeleteAction;
  /** @nullable */
  destinationCompanyId?: number | null;
}

export interface DeleteGlobalAssetCategoriesCommand {
  /** @nullable */
  ids?: number[] | null;
}

export interface DeleteGlobalAssetIntentCommand {
  /** @nullable */
  ids?: number[] | null;
}

export interface DeleteScheduledCallsCommand {
  /** @nullable */
  ids?: number[] | null;
}

export interface DeleteUserGroupCommand {
  /** @nullable */
  ids?: number[] | null;
}

export interface DeleteUsersFromGroupCommand {
  /** @nullable */
  ids?: number[] | null;
}

export interface DepartmentInvitationDto {
  id?: number;
  /** @nullable */
  inviteeEmail?: string | null;
  /** @nullable */
  companyId?: number | null;
  /** @nullable */
  departmentId?: number | null;
  /** @nullable */
  inviterId?: number | null;
  /** @nullable */
  createdTime?: string | null;
  /** @nullable */
  expirationTime?: string | null;
  /** @nullable */
  acceptedTime?: string | null;
  role?: UserRole;
  invitationStatus?: InvitationStatus;
}

export interface DialogFeedbackDto {
  id?: number;
  /** @nullable */
  createdBy?: number | null;
  /** @nullable */
  createdByUserName?: string | null;
  createdDate?: string;
  /** @nullable */
  modifiedByUserName?: string | null;
  emoji?: FeedbackEmoji;
  /** @nullable */
  feedback: string | null;
  /** @nullable */
  metadata: string | null;
}

export interface DialogStatisticDto {
  id?: number;
  /** @nullable */
  createdBy?: number | null;
  /** @nullable */
  createdByUserName?: string | null;
  createdDate?: string;
  /** @nullable */
  modifiedByUserName?: string | null;
  companyId?: number;
  /** @nullable */
  companyName: string | null;
  /** @nullable */
  departmentName: string | null;
  sceneId?: number;
  sceneVersionId?: number;
  /** @nullable */
  langCode: string | null;
  sessionId?: string;
  /** @nullable */
  sceneName: string | null;
  start?: string;
  /** @nullable */
  end?: string | null;
  respondent: DialogStatisticRespondentDto;
  timestamp?: string;
  /** @nullable */
  intents?: DialogStatisticIntentDto[] | null;
  /** @nullable */
  qualityParams?: QualitySettingsDto[] | null;
  /** @nullable */
  departmentId?: number | null;
  totalScores?: number;
  totalScoresMax?: number;
  /** @nullable */
  callRecordingUrl: string | null;
  /** @nullable */
  totalEvaluationScore?: number | null;
  /** @nullable */
  notesEvaluationScore?: number | null;
  notesEvaluationScorePending?: boolean;
  notesEvaluationFailed?: boolean;
  isPhoneConversation?: boolean;
  /** @nullable */
  phoneNumber?: string | null;
  hasNotes?: boolean;
}

export interface DialogStatisticGlobalIntentPredictionDto {
  globalIntentId?: number;
  /** @nullable */
  globalIntentName: string | null;
  /** @nullable */
  globalIntentSamples?: DialogStatisticGlobalIntentPredictionSampleDto[] | null;
  /** @nullable */
  globalCategoryName?: string | null;
  originalIntentId?: number;
}

export interface DialogStatisticGlobalIntentPredictionSampleDto {
  /** @nullable */
  text: string | null;
}

export interface DialogStatisticIntentDto {
  id?: number;
  /** @nullable */
  voiceId?: string | null;
  number?: number;
  currentBlock?: BlockDto;
  nextBlock?: BlockDto;
  start?: string;
  end?: string;
  /** @nullable */
  userSays: string | null;
  /** @nullable */
  responseText: string | null;
  /** @nullable */
  originalIntentText?: string | null;
  /** @nullable */
  originalIntentId?: number | null;
  /** @nullable */
  originalIntentName?: string | null;
  isFallback?: boolean;
  /** @nullable */
  selectedScenarioPersonaId?: number | null;
  verifyStatus?: boolean;
  scores?: number;
  corrected?: boolean;
  color?: QualityLevel;
  previousColor?: QualityLevel;
  /** @nullable */
  intentsInPrediction?: DialogStatisticIntentPredictionDto[] | null;
}

export interface DialogStatisticIntentPredictionDto {
  originalIntentId?: number;
  /** @nullable */
  originalIntentName: string | null;
  /** @nullable */
  samples?: DialogStatisticIntentPredictionSampleDto[] | null;
  /** @nullable */
  globalIntentsInPrediction?: DialogStatisticGlobalIntentPredictionDto[] | null;
}

export interface DialogStatisticIntentPredictionSampleDto {
  /** @nullable */
  text: string | null;
}

export interface DialogStatisticKpiDetailsDto {
  aiAnalysisCompleted?: boolean;
  evaluationScorePending?: boolean;
  notesEvaluationScorePending?: boolean;
  hasNotes?: boolean;
  /** @nullable */
  evaluations?: EvaluationDto[] | null;
  /** @nullable */
  notesEvaluations?: EvaluationDto[] | null;
}

export interface DialogStatisticRespondentDto {
  userId?: number;
  /** @nullable */
  userName: string | null;
  /** @nullable */
  email: string | null;
}

export interface EditUserAudioSettingsCommand {
  speechThreshold?: number;
  speechWaitingTime?: number;
  smartTurnEnabled?: boolean;
}

export interface EditUserCommand {
  id?: number;
  role?: UserRole;
  /** @nullable */
  departmentId?: number | null;
  /** @nullable */
  phone?: string | null;
  /** @nullable */
  name?: string | null;
  hideScenarioContent?: boolean;
  hasSklls?: boolean;
  hasInterpreter?: boolean;
  hasExercises?: boolean;
}

export interface EditUserProfileCommand {
  /** @nullable */
  phone?: string | null;
  /** @nullable */
  name?: string | null;
}

export interface EndCallCommand {
  /** @nullable */
  callSid?: string | null;
}

export type EndReason = (typeof EndReason)[keyof typeof EndReason];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EndReason = {
  Finish: 'Finish',
  CanceledByUser: 'CanceledByUser',
  BrowserClosed: 'BrowserClosed',
  Timeout: 'Timeout',
  Provisional: 'Provisional',
  Regenerate: 'Regenerate'
} as const;

export interface EvaluationDto {
  id?: number;
  /** @nullable */
  createdBy?: number | null;
  /** @nullable */
  createdByUserName?: string | null;
  createdDate?: string;
  /** @nullable */
  modifiedByUserName?: string | null;
  companyId?: number;
  evaluationProtocolId?: number;
  type?: EvaluationType;
  /** @nullable */
  evaluationElements?: EvaluationElementDto[] | null;
}

export interface EvaluationElementDto {
  id?: number;
  evaluationId?: number;
  /** @nullable */
  score?: number | null;
  /** @nullable */
  text?: string | null;
  /** @nullable */
  choice?: string | null;
  /** @nullable */
  yesNo?: boolean | null;
  /** @nullable */
  explanation?: string | null;
  /** @nullable */
  evaluationProtocolElement?: string | null;
}

export interface EvaluationProtocol {
  id?: number;
  /** @nullable */
  name: string | null;
  /** @nullable */
  languageCode: string | null;
  /** @nullable */
  evaluationProtocolCompanies?: EvaluationProtocolCompany[] | null;
  /** @nullable */
  protocolCategories?: EvaluationProtocolCategory[] | null;
}

export interface EvaluationProtocolCategory {
  id?: number;
  /** @nullable */
  name: string | null;
  order?: number;
  evaluationProtocolId?: number;
}

export interface EvaluationProtocolCategoryDto {
  id?: number;
  /** @nullable */
  name?: string | null;
  order?: number;
  evaluationProtocolId?: number;
  /** @nullable */
  protocolElements?: EvaluationProtocolElementDto[] | null;
}

export interface EvaluationProtocolCompany {
  evaluationProtocolId?: number;
  evaluationProtocol?: EvaluationProtocol;
  companyId?: number;
  company?: Company;
  access?: AccessLevel;
}

/**
 * DTO returned inside ScenarioEditor.Api.Dto.ConversationEvaluation.EvaluationProtocolDto that shows
which company has which access level to the protocol.
 */
export interface EvaluationProtocolCompanyDto {
  id?: number;
  companyId?: number;
  access?: AccessLevel;
}

/**
 * Public-facing representation of an Evaluation Protocol.
Now includes the per-company access level instead of plain Ids.
 */
export interface EvaluationProtocolDto {
  id?: number;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  languageCode?: string | null;
  /**
   * List of companies that have this protocol assigned, together with
their access level (read / edit).
   * @nullable
   */
  companies?: EvaluationProtocolCompanyDto[] | null;
  /** Number of <em>other</em> companies (excluding the caller’s company) this protocol is shared with. */
  otherCompaniesCount?: number;
  /** @nullable */
  protocolCategories?: EvaluationProtocolCategoryDto[] | null;
}

export interface EvaluationProtocolElement {
  id?: number;
  evaluationProtocolCategoryId?: number;
  order?: number;
  /** @nullable */
  name?: string | null;
  type?: EvaluationProtocolElementType;
  /** @nullable */
  scaleMin?: number | null;
  /** @nullable */
  scaleMax?: number | null;
  /** @nullable */
  choices?: string | null;
  explanationEnabled?: boolean;
  /** @nullable */
  description: string | null;
}

export interface EvaluationProtocolElementDto {
  id?: number;
  evaluationProtocolCategoryId?: number;
  order?: number;
  /** @nullable */
  name?: string | null;
  type?: EvaluationProtocolElementType;
  /** @nullable */
  scaleMin?: number | null;
  /** @nullable */
  scaleMax?: number | null;
  /** @nullable */
  choices?: string | null;
  explanationEnabled?: boolean;
  /** @nullable */
  description?: string | null;
}

export type EvaluationProtocolElementType =
  (typeof EvaluationProtocolElementType)[keyof typeof EvaluationProtocolElementType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EvaluationProtocolElementType = {
  Numeric: 'Numeric',
  FreeText: 'FreeText',
  MultipleChoice: 'MultipleChoice',
  YesNo: 'YesNo'
} as const;

export interface EvaluationProtocolUsageDto {
  scenarioId?: number;
  /** @nullable */
  scenarioName: string | null;
  /** @nullable */
  organizationId?: number | null;
  /** @nullable */
  organizationName: string | null;
}

export type EvaluationType = (typeof EvaluationType)[keyof typeof EvaluationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EvaluationType = {
  Conversation: 'Conversation',
  Notes: 'Notes'
} as const;

export interface ExerciseContactDto {
  id?: number;
  exerciseId?: number;
  /** @nullable */
  name: string | null;
  /** @nullable */
  phoneNumber: string | null;
  /** @nullable */
  type: string | null;
}

export interface ExerciseConversationDto {
  id?: number;
  playbookItemId?: number;
  dialogStatisticId?: number;
  /** @nullable */
  summary?: string | null;
}

export interface ExerciseDto {
  id?: number;
  companyId?: number;
  /** @nullable */
  title: string | null;
  /** @nullable */
  description?: string | null;
  scheduledDateTime?: string;
  scheduledEndDateTime?: string;
  /** @nullable */
  startedDateTime?: string | null;
  /** @nullable */
  endedDateTime?: string | null;
  /** @nullable */
  contactList?: ExerciseContactDto[] | null;
  /** @nullable */
  playbook?: PlaybookItemDto[] | null;
}

export type ExerciseScheduleCascadeMode =
  (typeof ExerciseScheduleCascadeMode)[keyof typeof ExerciseScheduleCascadeMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExerciseScheduleCascadeMode = {
  shift_all: 'shift_all',
  save_only: 'save_only'
} as const;

export type ExportFormat = (typeof ExportFormat)[keyof typeof ExportFormat];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExportFormat = {
  Xlsx: 'Xlsx',
  Csv: 'Csv'
} as const;

export type FeedbackEmoji = (typeof FeedbackEmoji)[keyof typeof FeedbackEmoji];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FeedbackEmoji = {
  Good: 'Good',
  Neutral: 'Neutral',
  Bad: 'Bad'
} as const;

export interface FileAttachment {
  id?: number;
  scenarioId?: number;
  scenario?: Scenario;
  fileType?: FileTypes;
  /** @nullable */
  blobName: string | null;
  /** @nullable */
  fileName: string | null;
  fileSize?: number;
  /** @nullable */
  checksumSha256: string | null;
  createdUtc?: string;
}

export type FileTypes = (typeof FileTypes)[keyof typeof FileTypes];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FileTypes = {
  ScenarioPdf: 'ScenarioPdf'
} as const;

export type Gender = (typeof Gender)[keyof typeof Gender];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Gender = {
  Female: 'Female',
  Male: 'Male'
} as const;

export interface GenerateMagicPersonaPromptCommand {
  /** @nullable */
  text?: string | null;
  /** @nullable */
  instructions?: string | null;
  gender?: Gender;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  language?: string | null;
}

export interface GenerateMagicRolePromptCommand {
  /** @nullable */
  text?: string | null;
  /** @nullable */
  instructions?: string | null;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  language?: string | null;
}

export interface GeneratePersonaSentenceRequestDto {
  /** @minLength 1 */
  personaDescription: string;
  /** @nullable */
  topic?: string | null;
  /** @nullable */
  language?: string | null;
}

export interface GeneratePersonaSentenceResponseDto {
  /** @nullable */
  sentence?: string | null;
}

export interface GetLicenseUsageBatchRequest {
  companyIds: number[];
}

export interface GlobalAssetCategory {
  id?: number;
  /** @nullable */
  createdBy?: number | null;
  /** @nullable */
  modifiedBy?: number | null;
  createdByUser?: User;
  modifiedByUser?: User;
  createdDate?: string;
  modifiedDate?: string;
  /** @nullable */
  title?: string | null;
  /** @nullable */
  language?: string | null;
  company?: Company;
  /** @nullable */
  companyId?: number | null;
  /** @nullable */
  intents?: GlobalAssetIntent[] | null;
  /** @nullable */
  sharedCompanies?: Company[] | null;
}

export interface GlobalAssetCategoryDto {
  id?: number;
  /** @nullable */
  createdBy?: number | null;
  /** @nullable */
  createdByUserName?: string | null;
  createdDate?: string;
  /** @nullable */
  modifiedByUserName?: string | null;
  /** @nullable */
  title: string | null;
  /** @nullable */
  language: string | null;
  /** @nullable */
  companyId?: number | null;
  /** @nullable */
  sharedCompanies?: CompanyDto[] | null;
}

export interface GlobalAssetConnection {
  /** @nullable */
  name?: string | null;
  sceneId?: number;
}

export interface GlobalAssetFullDto {
  id?: number;
  /** @nullable */
  createdBy?: number | null;
  /** @nullable */
  createdByUserName?: string | null;
  createdDate?: string;
  /** @nullable */
  modifiedByUserName?: string | null;
  /** @nullable */
  title: string | null;
  /** @nullable */
  language: string | null;
  /** @nullable */
  companyId?: number | null;
  /** @nullable */
  intents?: GlobalAssetIntentDto[] | null;
  /** @nullable */
  sharedCompanies?: CompanyDto[] | null;
}

export interface GlobalAssetIntent {
  id?: number;
  /** @nullable */
  createdBy?: number | null;
  /** @nullable */
  modifiedBy?: number | null;
  createdByUser?: User;
  modifiedByUser?: User;
  createdDate?: string;
  modifiedDate?: string;
  /** @nullable */
  title?: string | null;
  category?: GlobalAssetCategory;
  categoryId?: number;
  /** @nullable */
  samples?: GlobalAssetSample[] | null;
  /** @nullable */
  blocks?: Block[] | null;
}

export interface GlobalAssetIntentDto {
  id?: number;
  /** @nullable */
  createdBy?: number | null;
  /** @nullable */
  createdByUserName?: string | null;
  createdDate?: string;
  /** @nullable */
  modifiedByUserName?: string | null;
  /** @nullable */
  title: string | null;
  categoryId?: number;
  /** @nullable */
  samples?: GlobalAssetSampleDto[] | null;
}

export interface GlobalAssetSample {
  id?: number;
  intent?: GlobalAssetIntent;
  /** @nullable */
  text?: string | null;
}

export interface GlobalAssetSampleDto {
  id?: number;
  /** @nullable */
  text: string | null;
}

export interface Group {
  id?: number;
  /** @nullable */
  groupId: string | null;
  /** @nullable */
  name: string | null;
  tenant?: Tenant;
  tenantId?: number;
  company?: Company;
  companyId?: number;
}

export interface InitPersonaSessionCommand {
  gender?: Gender;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  language?: string | null;
  ttsProvider?: TtsProvider;
  /** @nullable */
  voiceId?: string | null;
  /** @nullable */
  description?: string | null;
}

export interface IntentPhrase {
  id?: number;
  /** @nullable */
  text: string | null;
}

export interface IntentPhraseDto {
  id?: number;
  /** @nullable */
  text: string | null;
}

export type InvitationStatus = (typeof InvitationStatus)[keyof typeof InvitationStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InvitationStatus = {
  Invited: 'Invited',
  Expired: 'Expired',
  Accepted: 'Accepted',
  Revoked: 'Revoked'
} as const;

export interface InviteMultipleUsersCommand {
  companyId?: number;
  /** @nullable */
  departmentId?: number | null;
  /** @nullable */
  emails?: string[] | null;
  /** @nullable */
  tenantId?: string | null;
  /** @nullable */
  tenantDomain?: string | null;
  hasSklls?: boolean;
  hasInterpreter?: boolean;
  hasExercises?: boolean;
  role?: UserRole;
}

/**
 * Data transfer object for job status
 */
export interface JobStatusDto {
  id?: number;
  /** The unique identifier of the job */
  jobId?: string;
  /**
   * The type of task being executed
   * @nullable
   */
  taskType: string | null;
  /**
   * Current status of the job (Queued, Processing, Completed, Failed)
   * @nullable
   */
  status: string | null;
  /** Time when the job was created */
  createdAt?: string;
  /**
   * Time when job processing started
   * @nullable
   */
  startedAt?: string | null;
  /**
   * Time when job processing was completed
   * @nullable
   */
  completedAt?: string | null;
  /** Time of the last status update */
  updatedAt?: string;
  /**
   * Error message if job failed
   * @nullable
   */
  errorMessage?: string | null;
  /**
   * Result summary when job completed successfully
   * @nullable
   */
  resultMessage?: string | null;
  /**
   * Payload in JSON format
   * @nullable
   */
  payloadJson: string | null;
  /**
   * The topic (LavinMQ stream name) the job was published to.
Used to distinguish jobs from different environments that share a database
(e.g. local dev vs. Azure dev).
   * @nullable
   */
  topic?: string | null;
}

export type Llm = (typeof Llm)[keyof typeof Llm];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Llm = {
  Gpt3_5: 'Gpt3_5',
  Gpt4: 'Gpt4',
  Gpt4o: 'Gpt4o',
  Claude3Haiku: 'Claude3Haiku',
  Claude3Sonnet: 'Claude3Sonnet',
  Claude3Opus: 'Claude3Opus',
  Claude35Sonnet: 'Claude35Sonnet',
  MistralTiny: 'MistralTiny',
  MistralSmall: 'MistralSmall',
  MistralMedium: 'MistralMedium',
  MistralLarge: 'MistralLarge',
  DBRX: 'DBRX',
  Llama3_8B: 'Llama3_8B',
  Llama3_70B: 'Llama3_70B',
  Gpt4oMini: 'Gpt4oMini',
  o3Mini: 'o3Mini',
  Gpt4_1: 'Gpt4_1',
  Gpt4_1mini: 'Gpt4_1mini',
  Gpt4_1nano: 'Gpt4_1nano',
  Gpt5_2: 'Gpt5_2',
  Gpt5_4: 'Gpt5_4',
  o4Mini: 'o4Mini',
  Gemini2_5Pro: 'Gemini2_5Pro',
  Gemini2_5Flash: 'Gemini2_5Flash',
  Gemini2_5FlashLite: 'Gemini2_5FlashLite',
  Gemini3Flash: 'Gemini3Flash',
  GptOss_120B: 'GptOss_120B',
  KimiK2Instruct_0905: 'KimiK2Instruct_0905',
  Qwen3_32B: 'Qwen3_32B'
} as const;

export interface LicenseAgreement {
  id?: number;
  companyId?: number;
  company?: Company;
  /** @nullable */
  departmentId?: number | null;
  department?: CompanyDepartment;
  skllsSeats?: number;
  interpreterSeats?: number;
  exercisesSeats?: number;
  startTime?: string;
  expiryTime?: string;
}

export interface LicenseAgreementDto {
  id?: number;
  companyId?: number;
  /** @nullable */
  companyName: string | null;
  /** @nullable */
  departmentId?: number | null;
  /** @nullable */
  departmentName?: string | null;
  skllsSeats?: number;
  interpreterSeats?: number;
  exercisesSeats?: number;
  startTime?: string;
  expiryTime?: string;
}

export interface LicenseUsageDto {
  companyId?: number;
  /** @nullable */
  departmentId?: number | null;
  totalSkllsSeats?: number;
  usedSkllsSeats?: number;
  availableSkllsSeats?: number;
  totalInterpreterSeats?: number;
  usedInterpreterSeats?: number;
  availableInterpreterSeats?: number;
  totalExercisesSeats?: number;
  usedExercisesSeats?: number;
  availableExercisesSeats?: number;
  /** @nullable */
  sharedPoolSkllsSeats?: number | null;
  /** @nullable */
  sharedPoolSkllsUsed?: number | null;
  /** @nullable */
  sharedPoolSkllsAvailable?: number | null;
  /** @nullable */
  sharedPoolInterpreterSeats?: number | null;
  /** @nullable */
  sharedPoolInterpreterUsed?: number | null;
  /** @nullable */
  sharedPoolInterpreterAvailable?: number | null;
  /** @nullable */
  sharedPoolExercisesSeats?: number | null;
  /** @nullable */
  sharedPoolExercisesUsed?: number | null;
  /** @nullable */
  sharedPoolExercisesAvailable?: number | null;
}

export interface MonthlyStatisticDto {
  month?: string;
  conversationCount?: number;
  averageScore?: number;
  uniqueUsers?: number;
}

export type OnCompanyDeleteAction = (typeof OnCompanyDeleteAction)[keyof typeof OnCompanyDeleteAction];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OnCompanyDeleteAction = {
  DeleteUsers: 'DeleteUsers',
  MoveUsers: 'MoveUsers'
} as const;

/**
 * Generic wrapper for paged API responses.
 */
export interface PagedResultDtoJobStatusDto {
  /**
   * Result items for the requested page.
   * @nullable
   */
  items: JobStatusDto[] | null;
  /** Total number of items across all pages. */
  totalCount?: number;
}

/**
 * Generic wrapper for paged API responses.
 */
export interface PagedResultDtoPersonaSearchItemDto {
  /**
   * Result items for the requested page.
   * @nullable
   */
  items: PersonaSearchItemDto[] | null;
  /** Total number of items across all pages. */
  totalCount?: number;
}

/**
 * Generic wrapper for paged API responses.
 */
export interface PagedResultDtoScenarioSearchItemDto {
  /**
   * Result items for the requested page.
   * @nullable
   */
  items: ScenarioSearchItemDto[] | null;
  /** Total number of items across all pages. */
  totalCount?: number;
}

export interface PartialListCourseDto {
  /** @nullable */
  data?: CourseDto[] | null;
  total?: number;
  skip?: number;
  page?: number;
}

export interface PartialListDialogStatisticDto {
  /** @nullable */
  data?: DialogStatisticDto[] | null;
  total?: number;
  skip?: number;
  page?: number;
}

export interface PartialListScheduledCallDto {
  /** @nullable */
  data?: ScheduledCallDto[] | null;
  total?: number;
  skip?: number;
  page?: number;
}

export interface PartialListUserGroupDto {
  /** @nullable */
  data?: UserGroupDto[] | null;
  total?: number;
  skip?: number;
  page?: number;
}

export interface Persona {
  id?: number;
  /** @nullable */
  name: string | null;
  /** @nullable */
  description?: string | null;
  /** @nullable */
  languageCode?: string | null;
  gender?: Gender;
  ttsProvider?: TtsProvider;
  /** @nullable */
  voiceName?: string | null;
  /** @nullable */
  voiceId?: string | null;
  /** @nullable */
  avatarUrl?: string | null;
  /** @nullable */
  personaCompanies?: PersonaCompany[] | null;
}

export interface PersonaAudioResponse {
  /** @nullable */
  audio: string | null;
  /** @nullable */
  text: string | null;
}

export interface PersonaCompany {
  personaId?: number;
  persona?: Persona;
  companyId?: number;
  company?: Company;
  access?: AccessLevel;
}

export interface PersonaCompanyAccessDto {
  companyId?: number;
  access?: AccessLevel;
}

/**
 * DTO describing which companies still lack access to a persona for a given scenario.
 */
export interface PersonaCompanyAccessInfoDto {
  personaId?: number;
  /** @nullable */
  personaName: string | null;
  /** @nullable */
  missingCompanyIds?: number[] | null;
  /** @nullable */
  missingCompanyNames?: string[] | null;
}

/**
 * DTO returned inside ScenarioEditor.Api.Dto.Persona.PersonaDto that shows
which company has which access level to the persona.
 */
export interface PersonaCompanyDto {
  id?: number;
  companyId?: number;
  access?: AccessLevel;
}

export interface PersonaDeletionValidationDto {
  canDelete?: boolean;
  /** @nullable */
  reasonIfCannot?: string | null;
  isSharedWithOtherOrganizations?: boolean;
  /** @nullable */
  scenariosUsingPersona?: PersonaUsageScenarioDto[] | null;
}

/**
 * Public-facing representation of a Persona.
Includes the per-company access level instead of plain Ids.
 */
export interface PersonaDto {
  id?: number;
  /** @nullable */
  name: string | null;
  /** @nullable */
  description: string | null;
  /** @nullable */
  languageCode: string | null;
  gender?: Gender;
  ttsProvider?: TtsProvider;
  /** @nullable */
  voiceName: string | null;
  /** @nullable */
  voiceId: string | null;
  /** @nullable */
  avatarUrl: string | null;
  /**
   * List of companies that have this persona assigned, together with
their access level (read / edit).
   * @nullable
   */
  companies?: PersonaCompanyDto[] | null;
  /** Number of <em>other</em> companies (excluding the caller's company) this persona is shared with. */
  otherCompaniesCount?: number;
}

/**
 * Compact persona summary returned from persona search.
Includes description text for search and selection flows.
 */
export interface PersonaSearchItemDto {
  id?: number;
  /** @nullable */
  name: string | null;
  /** @nullable */
  description: string | null;
  /** @nullable */
  languageCode: string | null;
  gender?: Gender;
  ttsProvider?: TtsProvider;
  /** @nullable */
  voiceName: string | null;
  /** @nullable */
  voiceId: string | null;
  /** @nullable */
  avatarUrl: string | null;
  otherCompaniesCount?: number;
}

export interface PersonaSessionInitResult {
  sessionId?: string;
  /** @nullable */
  audio: string | null;
  /** @nullable */
  text: string | null;
}

export type PersonaUsage = (typeof PersonaUsage)[keyof typeof PersonaUsage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PersonaUsage = {
  Default: 'Default',
  Intro: 'Intro',
  Fallback: 'Fallback'
} as const;

export interface PersonaUsageScenarioDto {
  scenarioId?: number;
  /** @nullable */
  scenarioName?: string | null;
  /** @nullable */
  organizationId?: number | null;
  /** @nullable */
  organizationName?: string | null;
}

export interface PlaybookItemDto {
  id?: number;
  exerciseId?: number;
  scenarioId?: number;
  /** @nullable */
  description?: string | null;
  scheduledDateTime?: string;
  /** @nullable */
  endedDateTime?: string | null;
  /** @nullable */
  fromExerciseContactId?: number | null;
  toExerciseContactId?: number;
  /** @nullable */
  conversations?: ExerciseConversationDto[] | null;
  /** Whether a delayed job has been scheduled for this item. */
  isScheduled?: boolean;
  /**
   * When the call was actually executed. Null if not yet executed.
   * @nullable
   */
  executedDateTime?: string | null;
}

export type PlaybookTimeCascadeMode = (typeof PlaybookTimeCascadeMode)[keyof typeof PlaybookTimeCascadeMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PlaybookTimeCascadeMode = {
  shift_following: 'shift_following',
  save_only: 'save_only'
} as const;

export interface PopularScenarioDto {
  /** @nullable */
  scenarioName?: string | null;
  /** @nullable */
  scenarioDescription?: string | null;
  usageCount?: number;
  /** @nullable */
  companyName?: string | null;
}

export interface ProblemDetails {
  /** @nullable */
  type?: string | null;
  /** @nullable */
  title?: string | null;
  /** @nullable */
  status?: number | null;
  /** @nullable */
  detail?: string | null;
  /** @nullable */
  instance?: string | null;
  [key: string]: unknown;
}

export interface ProcessDialogCommand {
  sessionId?: string;
  /** @nullable */
  text?: string | null;
  /** @nullable */
  speech?: string | null;
}

export interface ProcessResultDto {
  /** @nullable */
  sessionId?: string | null;
  lastBlock?: BlockDto;
  scenarioPersona?: ScenarioPersonaDto;
  prevBlock?: BlockDto;
  lastBlockId?: number;
  prevBlocKId?: number;
  lastBlockScenarioId?: number;
  prevBlockScenarioId?: number;
  /** @nullable */
  text?: string | null;
  scoresChanges?: number;
  scoresColor?: QualityLevel;
  previousColor?: QualityLevel;
  /** @nullable */
  originalIntentText?: string | null;
  /** @nullable */
  originalIntentId?: number | null;
  /** @nullable */
  originalIntentName?: string | null;
  isEnd?: boolean;
  isFallback?: boolean;
  intentHitTime?: string;
}

export interface ProtocolCompanyAccessDto {
  companyId?: number;
  access?: AccessLevel;
}

export type QualityLevel = (typeof QualityLevel)[keyof typeof QualityLevel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QualityLevel = {
  Unset: 'Unset',
  Bad: 'Bad',
  Acceptable: 'Acceptable',
  Good: 'Good'
} as const;

export interface QualitySettingsDto {
  origin?: QualityLevel;
  destination?: QualityLevel;
  value?: number;
}

export interface RespondWithPersonaAudioCommand {
  sessionId?: string;
  /** @nullable */
  text?: string | null;
}

export interface RestoreScenarioVersionCommand {
  scenarioId?: number;
  versionId?: number;
}

export interface Role {
  id?: number;
  /** @nullable */
  name: string | null;
  /** @nullable */
  languageCode: string | null;
  /** @nullable */
  description?: string | null;
  /** @nullable */
  scenarioPersonas?: ScenarioPersona[] | null;
  /** @nullable */
  roleCompanies?: RoleCompany[] | null;
}

export interface RoleCompany {
  roleId?: number;
  role?: Role;
  companyId?: number;
  company?: Company;
  access?: AccessLevel;
}

export interface RoleCompanyDto {
  id?: number;
  companyId?: number;
  access?: AccessLevel;
}

export interface RoleDto {
  id?: number;
  /** @nullable */
  name: string | null;
  /** @nullable */
  languageCode: string | null;
  /** @nullable */
  description?: string | null;
  access?: AccessLevel;
  otherCompaniesCount?: number;
}

export interface Scenario {
  id?: number;
  /** @nullable */
  createdBy?: number | null;
  /** @nullable */
  modifiedBy?: number | null;
  createdByUser?: User;
  modifiedByUser?: User;
  createdDate?: string;
  modifiedDate?: string;
  versionId?: number;
  /** @nullable */
  companyId?: number | null;
  /** @nullable */
  name: string | null;
  /** @nullable */
  description?: string | null;
  speed?: number;
  /** @nullable */
  langCode: string | null;
  /** @nullable */
  evaluationProtocolElements?: EvaluationProtocolElement[] | null;
  /** @nullable */
  blocks?: Block[] | null;
  /** @nullable */
  blockLinks?: BlockLink[] | null;
  /** @nullable */
  courses?: Course[] | null;
  sceneGroup?: ScenarioGroup;
  centerX?: number;
  centerY?: number;
  scale?: number;
  /** @nullable */
  scenarioContextIntro?: string | null;
  playScenarioContextOn?: boolean;
  /** @nullable */
  scenarioGroupId?: number | null;
  contextId?: number;
  context?: ScenarioContext;
  /**
   * @deprecated
   * @nullable
   */
  contexts?: ScenarioContext[] | null;
  isLlmEnabled?: boolean;
  llm?: Llm;
  /** @nullable */
  sharedCompanies?: Company[] | null;
  /** @nullable */
  scenarioCompanies?: ScenarioCompany[] | null;
  /** @nullable */
  scenarioPersonas?: ScenarioPersona[] | null;
  /** @nullable */
  variables?: Variable[] | null;
  /** @nullable */
  attachments?: FileAttachment[] | null;
  isPublished?: boolean;
  useStreaming?: boolean;
  isDecisionSupportEnabled?: boolean;
  notesEnabled?: boolean;
  /** @nullable */
  notesEvaluationProtocolElements?: EvaluationProtocolElement[] | null;
  maxTokens?: number;
}

export type ScenarioAccessLevel = (typeof ScenarioAccessLevel)[keyof typeof ScenarioAccessLevel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ScenarioAccessLevel = {
  Read: 'Read'
} as const;

export type ScenarioChangeType = (typeof ScenarioChangeType)[keyof typeof ScenarioChangeType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ScenarioChangeType = {
  ScenarioCreated: 'ScenarioCreated',
  ScenarioCopied: 'ScenarioCopied',
  ScenarioConvertedToShared: 'ScenarioConvertedToShared',
  ScenarioConvertedToUnshared: 'ScenarioConvertedToUnshared',
  ScenarioSharedWithCompany: 'ScenarioSharedWithCompany',
  ScenarioUnsharedWithCompany: 'ScenarioUnsharedWithCompany',
  ScenarioVersionRestored: 'ScenarioVersionRestored',
  ScenarioNameChanged: 'ScenarioNameChanged',
  ScenarioDescriptionChanged: 'ScenarioDescriptionChanged',
  ScenarioVoiceChanged: 'ScenarioVoiceChanged',
  SttProviderChanged: 'SttProviderChanged',
  LanguageChanged: 'LanguageChanged',
  IntroAudioChanged: 'IntroAudioChanged',
  IntentProcessingProviderChanged: 'IntentProcessingProviderChanged',
  LlmEnablingChanged: 'LlmEnablingChanged',
  LlmChanged: 'LlmChanged',
  ScenarioContextFactAdded: 'ScenarioContextFactAdded',
  ScenarioContextFactChanged: 'ScenarioContextFactChanged',
  ScenarioContextFactDeleted: 'ScenarioContextFactDeleted',
  ScenarioContextLocationAdded: 'ScenarioContextLocationAdded',
  ScenarioContextLocationChanged: 'ScenarioContextLocationChanged',
  ScenarioContextLocationDeleted: 'ScenarioContextLocationDeleted',
  ScenarioContextPersonaAdded: 'ScenarioContextPersonaAdded',
  ScenarioContextPersonaChanged: 'ScenarioContextPersonaChanged',
  ScenarioContextPersonaDeleted: 'ScenarioContextPersonaDeleted',
  PersonasChanged: 'PersonasChanged',
  BlockAdded: 'BlockAdded',
  BlockNameChanged: 'BlockNameChanged',
  BlockTypeChanged: 'BlockTypeChanged',
  BlockDescriptionChanged: 'BlockDescriptionChanged',
  BlockQualityLevelChanged: 'BlockQualityLevelChanged',
  BlockDeleted: 'BlockDeleted',
  BlockLinkAdded: 'BlockLinkAdded',
  BlockLinkDeleted: 'BlockLinkDeleted',
  BlockPersonaChanged: 'BlockPersonaChanged',
  AiResponseAdded: 'AiResponseAdded',
  AiResponseChanged: 'AiResponseChanged',
  AiResponseEmotionChanged: 'AiResponseEmotionChanged',
  AiResponseDeleted: 'AiResponseDeleted',
  IntentPhraseAdded: 'IntentPhraseAdded',
  IntentPhraseChanged: 'IntentPhraseChanged',
  IntentPhraseDeleted: 'IntentPhraseDeleted',
  GlobalIntentAdded: 'GlobalIntentAdded',
  GlobalIntentRemoved: 'GlobalIntentRemoved',
  UseStreamingChanged: 'UseStreamingChanged',
  MaxTokensChanged: 'MaxTokensChanged',
  VariableAdded: 'VariableAdded',
  VariableRemoved: 'VariableRemoved',
  VariableChanged: 'VariableChanged',
  VariableValueAdded: 'VariableValueAdded',
  VariableValueRemoved: 'VariableValueRemoved',
  VariableValueChanged: 'VariableValueChanged',
  CompanyVariableAdded: 'CompanyVariableAdded',
  CompanyVariableRemoved: 'CompanyVariableRemoved',
  CompanyVariableChanged: 'CompanyVariableChanged',
  IsPublishedChanged: 'IsPublishedChanged',
  IsDecisionSupportEnabledChanged: 'IsDecisionSupportEnabledChanged',
  NotesEnabledChanged: 'NotesEnabledChanged',
  NotesEvaluationProtocolElementsChanged: 'NotesEvaluationProtocolElementsChanged',
  EvaluationProtocolElementsChanged: 'EvaluationProtocolElementsChanged',
  SpeedChanged: 'SpeedChanged'
} as const;

export interface ScenarioCompany {
  scenarioId?: number;
  companyId?: number;
  adminEditAccess?: ScenarioAccessLevel;
  /** @nullable */
  scenarioGroupId?: number | null;
  scenarioGroup?: ScenarioGroup;
}

export interface ScenarioContext {
  id?: number;
  /** @nullable */
  facts?: ScenarioContextFact[] | null;
  scenarioId?: number;
  scenario?: Scenario;
}

export interface ScenarioContextDto {
  id?: number;
  /** @nullable */
  facts?: ScenarioContextFactDto[] | null;
}

export interface ScenarioContextFact {
  id?: number;
  /** @nullable */
  text: string | null;
  sceneContextId?: number;
  scenarioContext?: ScenarioContext;
}

export interface ScenarioContextFactDto {
  id?: number;
  /** @nullable */
  text: string | null;
}

export interface ScenarioDialogStatisticDto {
  sex?: Gender;
  /** @nullable */
  voiceName?: string | null;
  /** @nullable */
  voiceId?: string | null;
  /** @nullable */
  langCode?: string | null;
  ttsProvider?: TtsProvider;
}

export interface ScenarioDto {
  id?: number;
  /** @nullable */
  createdBy?: number | null;
  /** @nullable */
  createdByUserName?: string | null;
  createdDate?: string;
  /** @nullable */
  modifiedByUserName?: string | null;
  versionId?: number;
  /** @nullable */
  companyId?: number | null;
  /** @nullable */
  name: string | null;
  /** @nullable */
  description?: string | null;
  speed?: number;
  /** @nullable */
  langCode: string | null;
  ttsProvider?: TtsProvider;
  /** @nullable */
  evaluationProtocolElements?: EvaluationProtocolElementDto[] | null;
  /** @nullable */
  blocks?: BlockDto[] | null;
  /** @nullable */
  blockLinks?: BlockLinkDto[] | null;
  centerX?: number;
  centerY?: number;
  scale?: number;
  /** @nullable */
  scenarioContextIntro?: string | null;
  playScenarioContextOn?: boolean;
  startBlockId?: number;
  sceneGroupId?: number;
  /** @nullable */
  companyName?: string | null;
  context?: ScenarioContextDto;
  isLlmEnabled?: boolean;
  llm?: Llm;
  useStreaming?: boolean;
  isDecisionSupportEnabled?: boolean;
  notesEnabled?: boolean;
  /** @nullable */
  notesEvaluationProtocolElements?: EvaluationProtocolElementDto[] | null;
  maxTokens?: number;
  /** @nullable */
  sharedCompanies?: CompanyDto[] | null;
  /** @nullable */
  scenarioPersonas?: ScenarioPersonaDto[] | null;
  /** @nullable */
  variables?: VariableDto[] | null;
  isPublished?: boolean;
  hasPdf?: boolean;
}

export interface ScenarioGroup {
  id?: number;
  /** @nullable */
  title: string | null;
  company?: Company;
  companyId?: number;
  /** @nullable */
  scenarios?: Scenario[] | null;
  /** @nullable */
  sharedScenarios?: ScenarioCompany[] | null;
}

export interface ScenarioGroupDto {
  id?: number;
  /** @nullable */
  title: string | null;
  companyId?: number;
  /** @nullable */
  sceneIds?: number[] | null;
  /** @nullable */
  scenes?: ScenarioDto[] | null;
}

export interface ScenarioNoteDto {
  id?: number;
  sessionId?: string;
  /** @nullable */
  notes?: string | null;
  /** @nullable */
  submittedAt?: string | null;
}

export interface ScenarioNoteRequest {
  /**
   * @minLength 1
   * @maxLength 10000
   */
  notes: string;
}

export interface ScenarioPersona {
  id?: number;
  scenarioId?: number;
  personaId?: number;
  /** @nullable */
  personaUsages?: PersonaUsage[] | null;
  /** @nullable */
  roleId?: number | null;
}

export interface ScenarioPersonaDto {
  id?: number;
  scenarioId?: number;
  personaId?: number;
  /** @nullable */
  roleId?: number | null;
  /** @nullable */
  personaUsages?: PersonaUsage[] | null;
  role?: RoleDto;
  /** @nullable */
  roleName?: string | null;
  persona: PersonaDto;
}

export interface ScenarioSearchItemDto {
  id?: number;
  versionId?: number;
  /** @nullable */
  companyId?: number | null;
  /** @nullable */
  companyName?: string | null;
  /** @nullable */
  name: string | null;
  /** @nullable */
  description?: string | null;
  /** @nullable */
  langCode: string | null;
}

export interface ScenarioUpdateDto {
  id?: number;
  /** @nullable */
  createdBy?: number | null;
  /** @nullable */
  createdByUserName?: string | null;
  createdDate?: string;
  /** @nullable */
  modifiedByUserName?: string | null;
  sceneId?: number;
  versionId?: number;
  scenarioChangeType?: ScenarioChangeType;
  /** @nullable */
  scenarioChangeTypeName?: string | null;
  /** @nullable */
  oldValue?: string | null;
  /** @nullable */
  newValue?: string | null;
  /** @nullable */
  blockName?: string | null;
}

export interface ScheduledCallDto {
  id?: number;
  scenarioId?: number;
  /** @nullable */
  scenarioName: string | null;
  scheduledTime?: string;
  /** @nullable */
  targetName: string | null;
  /** @nullable */
  userId?: number | null;
  /** @nullable */
  companyId?: number | null;
  /** @nullable */
  companyName: string | null;
  /** @nullable */
  phoneNumber: string | null;
  status?: ScheduledCallStatus;
  speechRecognitionTimeout?: number;
  isLlmEnabled?: boolean;
}

export type ScheduledCallStatus = (typeof ScheduledCallStatus)[keyof typeof ScheduledCallStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ScheduledCallStatus = {
  Initial: 'Initial',
  InProgress: 'InProgress',
  Finished: 'Finished',
  Canceled: 'Canceled',
  Queued: 'Queued',
  NotCompleted: 'NotCompleted',
  NoAnswer: 'NoAnswer',
  Busy: 'Busy',
  WrongNumber: 'WrongNumber',
  Failed: 'Failed'
} as const;

export interface ScheduledCourse {
  id?: number;
  /** @nullable */
  createdBy?: number | null;
  /** @nullable */
  modifiedBy?: number | null;
  createdByUser?: User;
  modifiedByUser?: User;
  createdDate?: string;
  modifiedDate?: string;
  courseId?: number;
  /** @nullable */
  departmentId?: number | null;
  course: Course;
  department?: CompanyDepartment;
  startDate?: string;
  endDate?: string;
  /** @nullable */
  users?: User[] | null;
  /** @nullable */
  userGroups?: UserGroup[] | null;
  /** @nullable */
  scheduledCourseUsers?: ScheduledCourseUser[] | null;
  /** @nullable */
  scheduledCourseUserGroups?: ScheduledCourseUserGroup[] | null;
  /** @nullable */
  scheduledCourseNotifications?: ScheduledCourseNotification[] | null;
}

export interface ScheduledCourseAssignmentCommand {
  id?: number;
}

export interface ScheduledCourseDto {
  id?: number;
  /** @nullable */
  createdBy?: number | null;
  /** @nullable */
  createdByUserName?: string | null;
  createdDate?: string;
  /** @nullable */
  modifiedByUserName?: string | null;
  courseId?: number;
  departmentId?: number;
  /** @nullable */
  departmentName?: string | null;
  /** @nullable */
  courseTitle?: string | null;
  completedScenesCount?: number;
  scenesCount?: number;
  startDate?: string;
  endDate?: string;
  /** @nullable */
  users?: ScheduledCourseUserDto[] | null;
  /** @nullable */
  userGroups?: ScheduledCourseUserGroupDto[] | null;
}

export interface ScheduledCourseNotification {
  id?: number;
  /** @nullable */
  createdBy?: number | null;
  /** @nullable */
  modifiedBy?: number | null;
  createdByUser?: User;
  modifiedByUser?: User;
  createdDate?: string;
  modifiedDate?: string;
  scheduledCourseId?: number;
  scheduledCourse: ScheduledCourse;
  date?: string;
  /** @nullable */
  customText: string | null;
}

export interface ScheduledCourseNotificationDto {
  id?: number;
  /** @nullable */
  createdBy?: number | null;
  /** @nullable */
  createdByUserName?: string | null;
  createdDate?: string;
  /** @nullable */
  modifiedByUserName?: string | null;
  date?: string;
  /** @nullable */
  customText?: string | null;
}

export interface ScheduledCourseScenarioResultDto {
  scenario: ScenarioDto;
  dialogStatistic: DialogStatisticDto;
  /** @nullable */
  status?: string | null;
}

export interface ScheduledCourseUser {
  id?: number;
  /** @nullable */
  createdBy?: number | null;
  /** @nullable */
  modifiedBy?: number | null;
  createdByUser?: User;
  modifiedByUser?: User;
  createdDate?: string;
  modifiedDate?: string;
  scheduledCourseId?: number;
  scheduledCourse: ScheduledCourse;
  userId?: number;
  user: User;
}

export interface ScheduledCourseUserDto {
  id?: number;
  /** @nullable */
  createdBy?: number | null;
  /** @nullable */
  createdByUserName?: string | null;
  createdDate?: string;
  /** @nullable */
  modifiedByUserName?: string | null;
  /** @nullable */
  name?: string | null;
  userId?: number;
}

export interface ScheduledCourseUserGroup {
  id?: number;
  /** @nullable */
  createdBy?: number | null;
  /** @nullable */
  modifiedBy?: number | null;
  createdByUser?: User;
  modifiedByUser?: User;
  createdDate?: string;
  modifiedDate?: string;
  scheduledCourseId?: number;
  scheduledCourse: ScheduledCourse;
  userGroupId?: number;
  userGroup: UserGroup;
}

export interface ScheduledCourseUserGroupDto {
  id?: number;
  /** @nullable */
  createdBy?: number | null;
  /** @nullable */
  createdByUserName?: string | null;
  createdDate?: string;
  /** @nullable */
  modifiedByUserName?: string | null;
  /** @nullable */
  title?: string | null;
  userGroupId?: number;
}

export interface ShareEvaluationProtocolCommand {
  evaluationProtocolId?: number;
  /** @nullable */
  companies?: ProtocolCompanyAccessDto[] | null;
}

export interface ShareRoleDto {
  companyId: number;
  accessLevel?: AccessLevel;
}

export interface SimpleCompanyDto {
  id?: number;
  /** @nullable */
  name?: string | null;
}

export interface SimpleScenarioDto {
  id?: number;
  versionId?: number;
  /** @nullable */
  companyId?: number | null;
  /** @nullable */
  companyName?: string | null;
  /** @nullable */
  name: string | null;
  /** @nullable */
  description?: string | null;
  /** @nullable */
  sceneGroupId?: number | null;
  /** @nullable */
  sharedCompanies?: SimpleCompanyDto[] | null;
}

export type SortType = (typeof SortType)[keyof typeof SortType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SortType = {
  Asc: 'Asc',
  Desc: 'Desc'
} as const;

export interface Speaker {
  /** @nullable */
  id: string | null;
  ttsProvider?: TtsProvider;
  /** @nullable */
  languageCode: string | null;
  /** @nullable */
  name: string | null;
  sex?: Gender;
}

export interface SynthesizeSpeechCommand {
  /** @nullable */
  intentId?: number | null;
  service?: TtsProvider;
  sex?: Gender;
  /** @nullable */
  text?: string | null;
  /** @nullable */
  language?: string | null;
  /** @nullable */
  voiceName?: string | null;
  speed?: number;
  /** @nullable */
  voiceId?: string | null;
  /** @nullable */
  scenarioId?: number | null;
  /** @nullable */
  scenarioPersonaId?: number | null;
}

export interface TaskTemplateDto {
  /** @nullable */
  taskType?: string | null;
  payloadTemplate?: unknown;
}

export interface Tenant {
  id?: number;
  /** @nullable */
  name: string | null;
  /** @nullable */
  domain: string | null;
  /** @nullable */
  tenantId: string | null;
  externalTenant?: boolean;
  /** @nullable */
  groups?: Group[] | null;
  /** @nullable */
  companies?: Company[] | null;
}

export interface TenantDto {
  id?: number;
  /** @nullable */
  name: string | null;
  /** @nullable */
  domain: string | null;
  /** @nullable */
  tenantId: string | null;
}

export interface TestExceptionRequest {
  /** @nullable */
  message?: string | null;
}

export interface TextToSpeechCommand {
  /** @nullable */
  callSid?: string | null;
  /** @nullable */
  text?: string | null;
}

export interface TrendingScenariosCommand {
  companyId?: number;
  count?: number;
}

export interface TriggerJobRequest {
  /** @nullable */
  taskType: string | null;
  payload: unknown;
}

export type TtsProvider = (typeof TtsProvider)[keyof typeof TtsProvider];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TtsProvider = {
  Google: 'Google',
  InHouse: 'InHouse',
  Microsoft: 'Microsoft',
  ElevenLabs: 'ElevenLabs'
} as const;

export interface TwilioPhoneNumberDto {
  /** @nullable */
  phoneNumber: string | null;
  /** @nullable */
  friendlyName: string | null;
}

export interface UnshareEvaluationProtocolCommand {
  evaluationProtocolId?: number;
  /** @nullable */
  companyIds?: number[] | null;
}

export interface UnshareRoleDto {
  companyId: number;
}

export interface UpdateCompanyCommand {
  id?: number;
  /** @nullable */
  name: string | null;
  /** @nullable */
  users?: User[] | null;
  /** @nullable */
  departments?: CompanyDepartment[] | null;
  /** @nullable */
  scenarios?: Scenario[] | null;
  /** @nullable */
  scenarioGroups?: ScenarioGroup[] | null;
  /** @nullable */
  sharedScenarios?: Scenario[] | null;
  /** @nullable */
  sharedGlobalAssetCategories?: GlobalAssetCategory[] | null;
  /** @nullable */
  globalAssetCategories?: GlobalAssetCategory[] | null;
  /** @nullable */
  readonly externalName?: string | null;
  /** @nullable */
  groups?: Group[] | null;
  /** @nullable */
  tenants?: Tenant[] | null;
  /** @nullable */
  defaultLanguage?: string | null;
  /** @nullable */
  licenseAgreements?: LicenseAgreement[] | null;
  /** @nullable */
  evaluationProtocolCompanies?: EvaluationProtocolCompany[] | null;
  /** @nullable */
  personaCompanies?: PersonaCompany[] | null;
  /** @nullable */
  roleCompanies?: RoleCompany[] | null;
}

export interface UpdateCourseCommand {
  id?: number;
  /** @nullable */
  title?: string | null;
}

export interface UpdateEvaluationProtocolCategoryCommand {
  id?: number;
  /** @nullable */
  name?: string | null;
}

export interface UpdateEvaluationProtocolCommand {
  id?: number;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  languageCode?: string | null;
}

export interface UpdateEvaluationProtocolCompanyAccessCommand {
  evaluationProtocolId?: number;
  companyId?: number;
  access?: AccessLevel;
}

export interface UpdateEvaluationProtocolElementCommand {
  id?: number;
  evaluationProtocolCategoryId?: number;
  /** @nullable */
  name?: string | null;
  type?: EvaluationProtocolElementType;
  /** @nullable */
  scaleMin?: number | null;
  /** @nullable */
  scaleMax?: number | null;
  /** @nullable */
  choices?: string | null;
  explanationEnabled?: boolean;
  /** @nullable */
  description?: string | null;
}

export interface UpdateExerciseContactDto {
  id: number;
  /**
   * @minLength 0
   * @maxLength 200
   */
  name: string;
  /**
   * @minLength 0
   * @maxLength 50
   */
  phoneNumber: string;
  /** @minLength 1 */
  type: string;
}

export interface UpdateExerciseDto {
  id: number;
  /**
   * @minLength 0
   * @maxLength 200
   */
  title: string;
  /**
   * @minLength 0
   * @maxLength 2000
   * @nullable
   */
  description?: string | null;
  scheduledDateTime: string;
  scheduledEndDateTime: string;
  /** @nullable */
  startedDateTime?: string | null;
  /** @nullable */
  endedDateTime?: string | null;
}

export interface UpdateGlobalAssetCategoryCommand {
  /** @nullable */
  title?: string | null;
}

export interface UpdateGlobalAssetIntentCommand {
  /** @nullable */
  title?: string | null;
}

export interface UpdateLicenseAgreementDto {
  id: number;
  companyId: number;
  /** @nullable */
  departmentId?: number | null;
  /**
   * @minimum 0
   * @maximum 2147483647
   */
  skllsSeats: number;
  /**
   * @minimum 0
   * @maximum 2147483647
   */
  interpreterSeats: number;
  /**
   * @minimum 0
   * @maximum 2147483647
   */
  exercisesSeats: number;
  startTime: string;
  expiryTime: string;
}

/**
 * DTO for updating an existing persona.
 */
export interface UpdatePersonaDto {
  /** The ID of the persona to update. */
  id: number;
  /**
   * The name of the persona.
   * @minLength 0
   * @maxLength 100
   */
  name: string;
  /**
   * Optional description of the persona.
   * @minLength 0
   * @maxLength 500
   * @nullable
   */
  description?: string | null;
  /**
   * The language code for the persona (e.g., "en-US", "sv-SE").
   * @minLength 0
   * @maxLength 10
   */
  languageCode: string;
  gender: Gender;
  ttsProvider: TtsProvider;
  /**
   * The voice name to use with the TTS provider. Deprecated; prefer voiceId.
   * @minLength 0
   * @maxLength 100
   */
  voiceName: string;
  /**
   * Provider-stable voice identifier (e.g., Azure ShortName, Google voice name, ElevenLabs voice_id).
   * @minLength 0
   * @maxLength 100
   * @nullable
   */
  voiceId?: string | null;
  /**
   * Optional URL to an avatar image for the persona.
   * @minLength 0
   * @maxLength 500
   * @nullable
   */
  avatarUrl?: string | null;
}

export interface UpdatePlaybookItemDto {
  id: number;
  scenarioId: number;
  /**
   * @minLength 0
   * @maxLength 2000
   * @nullable
   */
  description?: string | null;
  scheduledDateTime: string;
  /** @nullable */
  endedDateTime?: string | null;
  /** @nullable */
  fromExerciseContactId?: number | null;
  toExerciseContactId: number;
}

export interface UpdateRoleDto {
  /** @nullable */
  name: string | null;
  /** @nullable */
  description?: string | null;
}

export interface UpdateScenarioContentCommand {
  id?: number;
  centerX?: number;
  centerY?: number;
  scale?: number;
  /** @nullable */
  blocks?: AddBlockCommand[] | null;
  /** @nullable */
  blockLinks?: AddBlockLinkCommand[] | null;
}

export interface UpdateScenarioGroupCommand {
  /** @nullable */
  title?: string | null;
}

export interface UpdateScenarioSettingsCommand {
  id?: number;
  /** @nullable */
  companyId?: number | null;
  /** @nullable */
  name?: string | null;
  speed?: number;
  /** @nullable */
  langCode?: string | null;
  /** @nullable */
  evaluationProtocolElements?: EvaluationProtocolElement[] | null;
  /** @nullable */
  scenarioPersonas?: ScenarioPersona[] | null;
  /** @nullable */
  scenarioContextIntro?: string | null;
  playScenarioContextOn?: boolean;
  context?: ScenarioContext;
  isLlmEnabled?: boolean;
  /** @nullable */
  description?: string | null;
  llm?: Llm;
  useStreaming?: boolean;
  isDecisionSupportEnabled?: boolean;
  notesEnabled?: boolean;
  /** @nullable */
  notesEvaluationProtocolElements?: EvaluationProtocolElement[] | null;
  maxTokens?: number;
  isPublished?: boolean;
  /** @nullable */
  variables?: VariableSettingsDto[] | null;
}

export interface UpdateScheduledCallCommand {
  scenarioId?: number;
  scheduledTime?: string;
  /** @nullable */
  targetName?: string | null;
  /** @nullable */
  userId?: number | null;
  /** @nullable */
  phoneNumber?: string | null;
  isLlmEnabled?: boolean;
  speechRecognitionTimeout?: number;
  isDigitsGatherEnabled?: boolean;
}

export interface UpdateScheduledCourseNotificationCommand {
  id?: number;
  date?: string;
  /** @nullable */
  customText?: string | null;
}

export interface UpdateScheduledCourseRequestCommand {
  /** @nullable */
  departmentId?: number | null;
  startDate?: string;
  endDate?: string;
}

export interface UpdateUserGroupCommand {
  /** @nullable */
  title?: string | null;
}

export interface UpdateUsersAdvancedSettingsCommand {
  /** @nullable */
  ids?: number[] | null;
  hideScenarioContent?: boolean;
}

export interface UpdateUsersDepartmentCommand {
  /** @nullable */
  ids?: number[] | null;
  /** @nullable */
  departmentId?: number | null;
}

export interface UpdateUsersLicenseFeaturesCommand {
  /**
   * @minItems 1
   * @nullable
   */
  ids?: number[] | null;
  /** @nullable */
  hasSklls?: boolean | null;
  /** @nullable */
  hasInterpreter?: boolean | null;
  /** @nullable */
  hasExercises?: boolean | null;
}

export interface UsageStatistic {
  month?: string;
  /** @nullable */
  companyName: string | null;
  scenarioRuns?: number;
}

export interface UsageStatisticsDto {
  overview?: UsageStatisticsOverviewDto;
  /** @nullable */
  monthlyBreakdown?: MonthlyStatisticDto[] | null;
  /** @nullable */
  topUsers?: UserConversationCountDto[] | null;
  /** @nullable */
  popularScenarios?: PopularScenarioDto[] | null;
}

export interface UsageStatisticsOverviewDto {
  totalConversations?: number;
  phoneConversation?: number;
  webConversation?: number;
}

export interface UsageStatisticsQuery {
  /** @nullable */
  from?: string | null;
  /** @nullable */
  to?: string | null;
  /** @nullable */
  companyId?: number | null;
  /** @nullable */
  departmentIds?: number[] | null;
  /** @nullable */
  userIds?: number[] | null;
  /** @nullable */
  scenarioIds?: number[] | null;
  userRole?: UserRole;
  /** @nullable */
  isPhoneConversation?: boolean | null;
}

export interface User {
  id?: number;
  role?: UserRole;
  /** @nullable */
  phone?: string | null;
  companyId?: number;
  company?: Company;
  /** @nullable */
  departmentId?: number | null;
  department?: CompanyDepartment;
  isAggreementAccepted?: boolean;
  hideScenarioContent?: boolean;
  speechThreshold?: number;
  speechWaitingTime?: number;
  smartTurnEnabled?: boolean;
  /** @nullable */
  userGroups?: UserGroup[] | null;
  /** @nullable */
  scheduledCourses?: ScheduledCourse[] | null;
  /** @nullable */
  scheduledCourseUsers?: ScheduledCourseUser[] | null;
  /** @nullable */
  name: string | null;
  /** @nullable */
  email: string | null;
  /** @nullable */
  externalUserId?: string | null;
  tenant?: Tenant;
  /** @nullable */
  tenantId?: number | null;
  group?: Group;
  /** @nullable */
  groupId?: number | null;
  hasSklls?: boolean;
  hasInterpreter?: boolean;
  hasExercises?: boolean;
}

export interface UserConversationCountDto {
  /** @nullable */
  userName?: string | null;
  conversationCount?: number;
  /** @nullable */
  departmentName?: string | null;
  /** @nullable */
  companyName?: string | null;
}

export interface UserDto {
  id?: number;
  role?: UserRole;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  phone?: string | null;
  companyId?: number;
  /** @nullable */
  companyName?: string | null;
  isAggreementAccepted?: boolean;
  hideScenarioContent?: boolean;
  speechThreshold?: number;
  speechWaitingTime?: number;
  smartTurnEnabled?: boolean;
  /** @nullable */
  departmentId?: number | null;
  /** @nullable */
  departmentName?: string | null;
  /** @nullable */
  externalOrganizationId?: string | null;
  /** @nullable */
  roleName?: string | null;
  tenant?: TenantDto;
  hasSklls?: boolean;
  hasInterpreter?: boolean;
  hasExercises?: boolean;
}

export interface UserGroup {
  id?: number;
  /** @nullable */
  createdBy?: number | null;
  /** @nullable */
  modifiedBy?: number | null;
  createdByUser?: User;
  modifiedByUser?: User;
  createdDate?: string;
  modifiedDate?: string;
  /** @nullable */
  title: string | null;
  company?: Company;
  companyId?: number;
  /** @nullable */
  departmentId?: number | null;
  department?: CompanyDepartment;
  /** @nullable */
  users?: User[] | null;
  /** @nullable */
  scheduledCourses?: ScheduledCourse[] | null;
  /** @nullable */
  scheduledCourseUserGroups?: ScheduledCourseUserGroup[] | null;
}

export interface UserGroupDto {
  id?: number;
  /** @nullable */
  createdBy?: number | null;
  /** @nullable */
  createdByUserName?: string | null;
  createdDate?: string;
  /** @nullable */
  modifiedByUserName?: string | null;
  /** @nullable */
  title: string | null;
  companyId?: number;
  /** @nullable */
  companyName: string | null;
  /** @nullable */
  departmentName?: string | null;
  /** @nullable */
  users?: UserDto[] | null;
}

export type UserRole = (typeof UserRole)[keyof typeof UserRole];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserRole = {
  Member: 'Member',
  Admin: 'Admin',
  Owner: 'Owner',
  SuperAdmin: 'SuperAdmin'
} as const;

export interface Variable {
  id?: number;
  /** @nullable */
  name?: string | null;
  scenario?: Scenario;
  scenarioId?: number;
  /** @nullable */
  values?: VariableValue[] | null;
}

export interface VariableDto {
  id?: number;
  /** @nullable */
  name: string | null;
  /** @nullable */
  value?: string | null;
  /** @nullable */
  companyId?: number | null;
  /** @nullable */
  values?: VariableValueDto[] | null;
}

export interface VariableSettingsDto {
  /** @nullable */
  id?: number | null;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  values?: VariableValueSettingsDto[] | null;
  /** @nullable */
  deletedValueIds?: number[] | null;
}

export interface VariableValue {
  id?: number;
  variableId?: number;
  variable?: Variable;
  /** @nullable */
  value?: string | null;
  /** @nullable */
  companyId?: number | null;
  company?: Company;
}

export interface VariableValueDto {
  id?: number;
  /** @nullable */
  value: string | null;
  /** @nullable */
  companyId?: number | null;
}

export interface VariableValueSettingsDto {
  /** @nullable */
  id?: number | null;
  /** @nullable */
  value?: string | null;
  /** @nullable */
  companyId?: number | null;
}

export type VoiceResponseUsecase = (typeof VoiceResponseUsecase)[keyof typeof VoiceResponseUsecase];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VoiceResponseUsecase = {
  Success: 'Success',
  Fail: 'Fail'
} as const;

export type CourseGetParams = {
  companyId?: number;
  skip?: number;
  take?: number;
};

export type CourseGetUserScheduledCourseResultsParams = {
  userId?: number;
};

export type DialogSessionInitSessionParams = {
  versionId?: number;
};

export type DialogStatisticsListDialogStatisticsServiceParams = {
  Skip?: number;
  Take?: number;
  SortOrder?: SortType;
  OrderBy?: string;
  From?: string;
  To?: string;
  Search?: string;
  CompanyName?: string;
  DepartmentName?: string;
  ScenarioName?: string;
  UserName?: string;
  DurationMin?: number;
  DurationMax?: number;
  ScoreMin?: number;
  ScoreMax?: number;
  IsPhoneConversation?: boolean;
  selectedId?: number;
};

export type GlobalAssetsCopyIntentToCompanyParams = {
  companyId?: number;
};

export type GlobalAssetsImportDataBodyOne = {
  file?: Blob;
};

export type GlobalAssetsImportDataBodyTwo = {
  file?: Blob;
};

export type JobStatusGetRecentJobsParams = {
  /**
   * The maximum number of recent jobs to return. Defaults to 100.
   */
  count?: number;
};

export type JobStatusGetRecentJobsPagedParams = {
  /**
   * 1-based page index
   */
  pageNumber?: number;
  /**
   * items per page
   */
  pageSize?: number;
  /**
   * Optional list of statuses to filter
   */
  statuses?: string[];
  /**
   * Optional list of task types to filter
   */
  taskTypes?: string[];
  /**
   * Optional search text for JobId or error message
   */
  searchText?: string;
  /**
   * Optional topic (LavinMQ stream name) to filter by
   */
  topic?: string;
};

export type LicenseAgreementsGetUsageParams = {
  companyId?: number;
  departmentId?: number;
};

export type PersonaSearchPersonasParams = {
  /**
   * Optional free-text match against persona name, description, or voice name.
   */
  query?: string;
  /**
   * Optional language code filter.
   */
  languageCode?: string;
  /**
   * Optional TTS provider filter.
   */
  ttsProvider?: TtsProvider;
  /**
   * Number of matching personas to skip.
   */
  skip?: number;
  /**
   * Maximum number of personas to return.
   */
  take?: number;
};

export type ProcessStartInboundCallBodyOne = {
  AccountSid?: string;
  ApiVersion?: string;
  CallSid: string;
  CallStatus?: string;
  Direction?: string;
  From?: string;
  FromCity?: string;
  FromCountry?: string;
  FromState?: string;
  FromZip?: string;
  Caller?: string;
  CallerCity?: string;
  CallerCountry?: string;
  CallerState?: string;
  CallerZip?: string;
  To?: string;
  ToCity?: string;
  ToCountry?: string;
  ToState?: string;
  ToZip?: string;
  Called?: string;
  CalledCity?: string;
  CalledCountry?: string;
  CalledState?: string;
  CalledZip?: string;
};

export type ProcessStartInboundCallBodyTwo = {
  AccountSid?: string;
  ApiVersion?: string;
  CallSid: string;
  CallStatus?: string;
  Direction?: string;
  From?: string;
  FromCity?: string;
  FromCountry?: string;
  FromState?: string;
  FromZip?: string;
  Caller?: string;
  CallerCity?: string;
  CallerCountry?: string;
  CallerState?: string;
  CallerZip?: string;
  To?: string;
  ToCity?: string;
  ToCountry?: string;
  ToState?: string;
  ToZip?: string;
  Called?: string;
  CalledCity?: string;
  CalledCountry?: string;
  CalledState?: string;
  CalledZip?: string;
};

export type RolesGetRolesParams = {
  langCode?: string;
  companyId?: number;
};

export type ScenarioGroupCreateGroupParams = {
  companyId?: number;
};

export type ScenarioGroupAddScenarioToGroupParams = {
  sceneIds?: number[];
};

export type ScenarioGroupRemoveScenesFromGroupParams = {
  sceneIds?: number[];
};

export type ScenariosSearchScenariosParams = {
  /**
   * Optional free-text match against scenario name, description, or organization name.
   */
  query?: string;
  /**
   * Optional scenario language filter.
   */
  langCode?: string;
  /**
   * Number of matching scenarios to skip.
   */
  skip?: number;
  /**
   * Maximum number of scenarios to return.
   */
  take?: number;
};

export type ScenariosUpdateScenarioPdfBodyOne = {
  pdfFile?: Blob;
};

export type ScenariosUpdateScenarioPdfBodyTwo = {
  pdfFile?: Blob;
};

export type ScheduledCallsGetParams = {
  skip?: number;
  take?: number;
};

export type ScheduledCallsUpdateStatusParams = {
  status?: ScheduledCallStatus;
};

export type SpeechRecognizeSpeechParams = {
  lng?: string;
};

export type SpeechRecognizeSpeechBodyOne = {
  file?: Blob;
};

export type SpeechRecognizeSpeechBodyTwo = {
  file?: Blob;
};

export type UserGroupGetParams = {
  skip?: number;
  take?: number;
};
